import { Map } from 'immutable';

import * as t from '../actions/practiceExamActionTypes';

const initialState = Map({
  timer: null,
  timerDisplay: '',
  timerStarted: false,

  remainingQuestions: [],
  currentQuestions: [], // At first, there will be shown 10 questions per page
  previousQuestions: [],

  answers: [],
  currentAnswers: [],

  results: {},
  isLoading: false,
  practiceExamAvailable: false,

  questions: [],
  resultsSummarized: [],
  practiceExam: null,

  submitPracticeExamSuccess: false,
  submitPracticeExamLoading: false,

  checkPracticeExamLoading: true,
  checkPracticeExamFlag: { type: null },

  reviewMode: false,
  retakeMode: false,

  customPracticeExam: null,
  customPracticeExamStatus: null,
  customPracticeExamLoading: false,
  customPracticeExamReferences: [],
  customPracticeExamReferencesLoading: false,

  customPracticeExamSettings: null,
  customPracticeExamSettingsLoading: false,
});

const reducer = function practiceExamReducer(state = initialState, action) {
  switch (action.type) {
    case t.SET_REVIEW_MODE:
      return state.set('reviewMode', action.value);
    case t.SET_RESULTS_SUMMARIZED:
      return state.set('resultsSummarized', action.results);
    case t.SET_CHECK_PRACTICE_EXAM_STATUS_LOADING:
      return state.set('checkPracticeExamLoading', action.value);
    case t.SET_CHECK_PRACTICE_EXAM_FLAG:
      return state.set('checkPracticeExamFlag', { type: action.flag });
    case t.SET_SUBMIT_PRACTICE_EXAM_LOADING:
      return state.set('submitPracticeExamLoading', action.value);
    case t.SET_SUBMIT_PRACTICE_EXAM_SUCCESS:
      return state.set('submitPracticeExamSuccess', action.value);
    case t.SET_PRACTICE_EXAM:
      return state.set('practiceExam', action.exam);
    case t.SET_NEW_DETAIL:
      const detail = action.detail;
      const currentDetails = state.get('resultsSummarized');
      if (currentDetails.length > 0) {
        const ExistingDetail = currentDetails.find(
          (d) => d.question === detail.question,
        );
        if (ExistingDetail) {
          const index = currentDetails.indexOf(ExistingDetail);
          currentDetails[index] = detail;
        } else {
          currentDetails.push(detail);
        }
      } else {
        currentDetails.push(detail);
      }
      return state.set('resultsSummarized', currentDetails);
    case t.SET_EXAM_QUESTIONS:
      return state.set('questions', action.questions);
    case t.START_TIMER_PRACTICE_EXAM:
      return state.set('timerStarted', action.value);
    case t.SET_PRACTICE_EXAM_AVAILABLE:
      return state.set('practiceExamAvailable', action.value);
    case t.SET_INITIAL_TIME_PRACTICE_EXAM:
      if (action.time === 0) {
        return state.set('timer', action.time).set('timerDisplay', '');
      }
      const s = action.time;
      const h = Math.floor(s / 3600);
      const m = Math.floor(s / 60) - h * 60;
      const secs = Math.floor(s - m * 60 - h * 3600);
      return state
        .set('timer', action.time)
        .set(
          'timerDisplay',
          `${h}:${m < 10 ? '0' : ''}${m}:${secs < 10 ? '0' : ''}${secs}`,
        );
    case t.UPDATE_TIMER_PRACTICE_EXAM:
      const sec = state.get('timer') - 1;
      const hours = Math.floor(sec / 3600);
      const minutes = Math.floor(sec / 60) - hours * 60;
      const seconds = Math.floor(sec - minutes * 60 - hours * 3600);
      return state
        .set(
          'timerDisplay',
          `${hours}:${minutes < 10 ? '0' : ''}${minutes}:${
            seconds < 10 ? '0' : ''
          }${seconds}`,
        )
        .set('timer', sec);

    case t.IS_LOADING_PRACTICE_EXAM_QUESTIONS:
      return state.set('isLoading', action.isLoading);
    case t.SET_RETAKE_MODE:
      return state.set('retakeMode', action.value);
    case t.SET_CUSTOM_PRACTICE_EXAM:
      return state.set('customPracticeExam', action.value);
    case t.SET_CUSTOM_PRACTICE_EXAM_STATUS:
      return state.set('customPracticeExamStatus', action.value);
    case t.SET_CUSTOM_PRACTICE_EXAM_LOADING:
      return state.set('customPracticeExamLoading', action.value);
    case t.SET_CUSTOM_PRACTICE_EXAM_REFERENCES:
      return state.set('customPracticeExamReferences', action.value);
    case t.SET_CUSTOM_PRACTICE_EXAM_REFERENCES_LOADING:
      return state.set('customPracticeExamReferencesLoading', action.value);
    case t.SET_CUSTOM_PRACTICE_EXAM_SETTINGS:
      return state.set('customPracticeExamSettings', action.value);
    case t.SET_CUSTOM_PRACTICE_EXAM_SETTINGS_LOADING:
      return state.set('customPracticeExamSettingsLoading', action.value);
    default:
      return state;
  }
};

export default reducer;
